import { API } from 'aws-amplify';
import { resolve } from '../../middleware/simple-promise';
import * as types from './types';

export const resetMappings = () => ({
  type: types.RESET
});

export const loadMappings = (next, limit, userId) => ({
  type: types.LOAD_MAPPINGS,
  payload: {
    promise: API.get("api", "mappings", { queryStringParameters: { next, limit, userId }}),
    next
  }
});

export const getMapping = (id, userId = '') => ({
  type: types.GET_MAPPING,
  payload: {
    promise: API.get("api", `mappings/${id}?userId=${userId}`),
    id
  }
});

export const saveMapping = (data) => ({
  type: types.SAVE_MAPPING,
  payload: {
    promise: API.post("api", "mappings", { body: data })
  }
});

export const updateMapping = (id, data) => ({
  type: types.UPDATE_MAPPING,
  payload: {
    promise: API.put("api", `mappings/${id}`, { body: data }),
    id
  }
});

export const createBulkMapping = (data) => ({
  type: types.CREATE_BULK_MAPPING,
  payload: {
    promise: API.post("api", "mappings/bulk", { body: data })
  }
});

export const deleteMapping = (id) => ({
  type: types.DELETE_MAPPING,
  payload: {
    promise: API.del("api", `mappings/${id}`),
    id
  }
});

export const searchMappings = (query, expand, userId = '') => ({
  type: types.SEARCH_MAPPING,
  payload: {
    promise: API.get('api', `mappings/search`, {
      queryStringParameters: {
        query,
        expand,
        userId
      }
    }),
    expand
  }
});

export const clearSearch = () => ({
  type: types.CLEAR_SEARCH_MAPPING
});

export const searchMappingsSuccess = (results) => ({
  type: resolve(types.SEARCH_MAPPING),
  payload: results
});
